import type { CheckoutStore } from './interfaces'

export const createInitialState = (): CheckoutStore => ({
  loading: false,
  paymentLocked: false,
  appliesForPromocode: false,
  furtherPayments: [],
  orderById: {},
  upsellOrderById: {},
  activeOrderId: null,
  paymentData: null,
  stripeClientSecret: null,
  paypalScriptUrl: null,
  modalFurtherPayments: false,
  blockPromoCode: false,
  paypalScriptReady: false,
  paymentError: false,
  notifyType: null,
  modalPaymentFailed: true,
  billingCountry: 'US',
  billingZipCode: '',
  billingCountryState: 'normal',
  billingZipStatus: undefined,
  billingConfirmed: false,
  modalFormSolidgate: false,
  modalCurrentMethodPayment: false,
})
